import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "./motion";
import { IMAGES } from "@/data/site";

export default function Loader({ onDone }) {
  const [hide, setHide] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setHide(true), 2100);
    const t2 = setTimeout(() => onDone(), 2750);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!hide && (
        <motion.div
          data-testid="luxury-loader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#1B1B1B]"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.7, ease: EASE }}
        >
          <motion.span
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mb-8 flex h-20 w-20 items-center justify-center overflow-hidden rounded-full bg-white shadow-[0_12px_40px_rgba(182,141,64,0.25)]"
          >
            <img src={IMAGES.logo} alt="Bengaluru Interior Design Company" className="h-16 w-16 object-contain" />
          </motion.span>
          <div className="overflow-hidden">
            <motion.p
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.15 }}
              className="font-display text-3xl md:text-5xl text-[#F7F5F2] tracking-tight"
            >
              Bengaluru <span className="italic text-[#B68D40]">Interiors</span>
            </motion.p>
          </div>
          <div className="overflow-hidden mt-3">
            <motion.p
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.35 }}
              className="font-num text-[11px] tracking-[0.5em] uppercase text-[#F7F5F2]/60"
            >
              By Sohan Raju
            </motion.p>
          </div>
          <motion.div
            className="mt-10 h-px w-40 origin-left bg-[#B68D40]"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.3, ease: EASE, delay: 0.5 }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
